module.exports = __webpack_public_path__ + "static/media/hospital2.15484591.svg";